import React, { useContext } from 'react'
import './App.css';
import { BrowserRouter, Redirect, useLocation } from 'react-router-dom'
import { AuthProvider, AuthContext } from './Auth/AuthContext'
import { TopbarProvider } from './Library/TopbarContext'
import { ModalProvider } from './Library/ModalContext'
import { NotifyProvider } from './Library/Notify'
import { LanguageProvider } from './Language/LanguageContext'
import { RoleProvider } from './Role/RoleContext'
import { CookieProvider } from './Library/CookieConsent'
import Compose from './Compose'
import Firebase from './Firebase'

import AuthStack from './Navigation/Authstack';
import MainStack from './Navigation/MainStack';
import { AlertModalProvider } from './Library/AlertModalContext';

function App() {
  return (
    <NotifyProvider>
      <Firebase/>
      <RoleProvider>
        <Compose components={[LanguageProvider, TopbarProvider, ModalProvider, AuthProvider, AlertModalProvider]}>
          <div id="app">
            <BrowserRouter>
              <AuthFlow/>
            </BrowserRouter>
          </div>
        </Compose>
      </RoleProvider>
    </NotifyProvider>
  );
}

function AuthFlow(){
  const authCx = useContext(AuthContext)
  const location = useLocation()

  return(
    /*
    Edit screen in
    Navigation folder
    */
    <CookieProvider>
      { authCx.isAuth ?
      <MainStack path="/"/>
      :
      <>
      { location.pathname !== "/login" 
        && location.pathname !== "/forgot"
        && location.pathname !== "/view-term"
        && !location.pathname.startsWith("/resetpassword")
        && !location.pathname.startsWith("/activate")
        ?
        <Redirect to="/login"/>
        : null
      }
      <AuthStack/>
      </>
      }
    </CookieProvider>
  )
}


export default App;
